import { Link, Typography } from '@mui/material';
import { useMemo, useState } from 'react';

/**
 * Clamp long body text with an inline "Read more" that triggers the same
 * open handler as the card (not a separate CTA button).
 */
export function ClampedText({
  text,
  lines = 3,
  sx,
  onReadMore,
  threshold = 110,
}) {
  const [expanded, setExpanded] = useState(false);
  const needsClamp = useMemo(() => {
    const value = String(text || '');
    return value.length > threshold || value.split(/\s+/).length > 22;
  }, [text, threshold]);

  if (!text) return null;

  if (!needsClamp || expanded) {
    return (
      <Typography
        sx={{
          color: 'text.secondary',
          lineHeight: 1.5,
          overflowWrap: 'break-word',
          ...sx,
        }}
      >
        {text}
        {needsClamp && expanded ? (
          <>
            {' '}
            <Link
              component="button"
              type="button"
              underline="hover"
              onClick={(e) => {
                e.stopPropagation();
                setExpanded(false);
              }}
              sx={{
                font: 'inherit',
                fontWeight: 700,
                color: 'secondary.main',
                verticalAlign: 'baseline',
              }}
            >
              Show less
            </Link>
          </>
        ) : null}
      </Typography>
    );
  }

  return (
    <Typography
      sx={{
        color: 'text.secondary',
        lineHeight: 1.5,
        display: '-webkit-box',
        WebkitLineClamp: lines,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        overflowWrap: 'break-word',
        ...sx,
      }}
    >
      {text}
      {' '}
      <Link
        component="button"
        type="button"
        underline="hover"
        onClick={(e) => {
          e.stopPropagation();
          if (onReadMore) {
            onReadMore();
            return;
          }
          setExpanded(true);
        }}
        sx={{
          font: 'inherit',
          fontWeight: 700,
          color: 'secondary.main',
          verticalAlign: 'baseline',
        }}
      >
        Read more
      </Link>
    </Typography>
  );
}
